export var ChatDataSource;
(function (ChatDataSource) {
    ChatDataSource["IConnect"] = "i-connect";
    ChatDataSource["MEAI"] = "me-ai";
    ChatDataSource["VeevaLink"] = "veeva-link";
})(ChatDataSource || (ChatDataSource = {}));
export var ChatSource;
(function (ChatSource) {
    ChatSource["MslInteractions"] = "msl-interactions";
    ChatSource["Presentations"] = "presentations";
    ChatSource["Profiles"] = "profiles";
    ChatSource["Surveys"] = "surveys";
    ChatSource["SurveyAnalyses"] = "survey_analyses";
    ChatSource["Dashboards"] = "dashboards";
    ChatSource["Text"] = "text";
    ChatSource["Transcripts"] = "transcripts";
})(ChatSource || (ChatSource = {}));
export var ChatCustomFilter;
(function (ChatCustomFilter) {
    ChatCustomFilter["AgentFilter"] = "agent-filter";
    ChatCustomFilter["CallCenterSource"] = "call-center-source";
    ChatCustomFilter["CallCenterSubSource"] = "call-center-sub-source";
    ChatCustomFilter["InsightType"] = "insight-type";
    ChatCustomFilter["InteractionDate"] = "interaction-date";
    ChatCustomFilter["InteractionStartEndDate"] = "interaction-start-end-date";
    ChatCustomFilter["InteractionType"] = "interaction-type";
    ChatCustomFilter["InteractionSubType"] = "interaction-sub-type";
    ChatCustomFilter["InteractionDetail"] = "interaction-detail";
    ChatCustomFilter["InterestArea"] = "interest-area";
    ChatCustomFilter["TherapeuticArea"] = "therapeutic-area";
    ChatCustomFilter["TherapeuticSubArea"] = "therapeutic-sub-area";
    ChatCustomFilter["Product"] = "product";
    ChatCustomFilter["Sentiment"] = "sentiment";
    ChatCustomFilter["Source"] = "source";
    ChatCustomFilter["PracticeSetting"] = "practice-setting";
})(ChatCustomFilter || (ChatCustomFilter = {}));
export var ChatFilterOperator;
(function (ChatFilterOperator) {
    ChatFilterOperator["Eq"] = "eq";
    ChatFilterOperator["Neq"] = "neq";
    // Gt = 'gt',
    // Gte = 'gte',
    // Lt = 'lt',
    // Lte = 'lte',
    ChatFilterOperator["MoreRecentThan"] = "more-recent-than";
    ChatFilterOperator["PriorTo"] = "prior-to";
})(ChatFilterOperator || (ChatFilterOperator = {}));
export var ChatDateFilter;
(function (ChatDateFilter) {
    ChatDateFilter["Last7Days"] = "last-7-days";
    ChatDateFilter["Last30Days"] = "last-30-days";
    ChatDateFilter["Last90Days"] = "last-90-days";
    ChatDateFilter["Last3Months"] = "last-3-months";
    ChatDateFilter["Last6Months"] = "last-6-months";
    ChatDateFilter["LastYear"] = "last-year";
    ChatDateFilter["Last2Years"] = "last-2-years";
    ChatDateFilter["Last5Years"] = "last-5-years";
})(ChatDateFilter || (ChatDateFilter = {}));
export const ChatDataSourcesMap = new Map([
    [ChatDataSource.IConnect, 'iConnect'],
    [ChatDataSource.MEAI, 'ME.AI'],
    [ChatDataSource.VeevaLink, 'Veeva Link'],
]);
export const ChatSourcesMap = new Map([
    [ChatSource.Profiles, 'Profiles'],
    [ChatSource.MslInteractions, 'CRM Interactions'],
    [ChatSource.Presentations, 'Presentations'],
    [ChatSource.Surveys, 'Survey Data'],
    [ChatSource.SurveyAnalyses, 'Survey Analyses'],
    [ChatSource.Dashboards, 'Dashboards'],
    [ChatSource.Text, 'Text'],
    [ChatSource.Transcripts, 'Transcripts'],
]);
export const chatCustomFilterNamesMap = {
    [ChatCustomFilter.CallCenterSource]: 'Call Center Source',
    [ChatCustomFilter.CallCenterSubSource]: 'Call Center Sub Source',
    [ChatCustomFilter.InteractionDate]: 'Interaction Date',
    [ChatCustomFilter.InteractionType]: 'Interaction Type',
    [ChatCustomFilter.InteractionSubType]: 'Interaction Sub Type',
    [ChatCustomFilter.InteractionDetail]: 'Interaction Detail',
    [ChatCustomFilter.TherapeuticArea]: 'Therapeutic Area',
    [ChatCustomFilter.TherapeuticSubArea]: 'Therapeutic Sub Area',
    [ChatCustomFilter.Product]: 'Product',
    [ChatCustomFilter.Sentiment]: 'Sentiment',
    [ChatCustomFilter.Source]: 'Source',
    [ChatCustomFilter.InsightType]: 'Insight Type',
    [ChatCustomFilter.InterestArea]: 'Interest Area',
    [ChatCustomFilter.PracticeSetting]: 'Practice Setting',
    [ChatCustomFilter.AgentFilter]: 'Agent Filter',
    [ChatCustomFilter.InteractionStartEndDate]: 'Interaction Start/End Date',
};
export const chatFilterOperatorsMap = {
    [ChatFilterOperator.Eq]: 'Equals',
    [ChatFilterOperator.Neq]: 'Not Equals',
    // [ChatFilterOperator.Gt]: 'Greater Than',
    // [ChatFilterOperator.Gte]: 'Greater Than or Equals',
    // [ChatFilterOperator.Lt]: 'Less Than',
    // [ChatFilterOperator.Lte]: 'Less Than or Equals',
    [ChatFilterOperator.MoreRecentThan]: 'More Recent Than',
    [ChatFilterOperator.PriorTo]: 'Prior To',
};
export const chatDateFiltersMap = {
    [ChatDateFilter.Last7Days]: 'Last 7 Days',
    [ChatDateFilter.Last30Days]: 'Last 30 Days',
    [ChatDateFilter.Last90Days]: 'Last 90 Days',
    [ChatDateFilter.Last3Months]: 'Last 3 Months',
    [ChatDateFilter.Last6Months]: 'Last 6 Months',
    [ChatDateFilter.LastYear]: 'Last Year',
    [ChatDateFilter.Last2Years]: 'Last 2 Years',
    [ChatDateFilter.Last5Years]: 'Last 5 Years',
};
